export const scrollToElement = (element: HTMLElement | null, containerId?: string): Promise<void> => {
  return new Promise((resolve) => {
    if (!element) {
      resolve();
      return;
    }

    if (!containerId) {
      element.scrollIntoView({ behavior: 'smooth' });

      // Use requestAnimationFrame to wait for the next frame
      requestAnimationFrame(() => {
        resolve();
      });
      return;
    }
    const container = document.getElementById(containerId);
    if (!container) {
      resolve();
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const scrollTop = elementRect.top - containerRect.top + container.scrollTop;

    container.scrollTo({ top: scrollTop, behavior: 'smooth' });

    // Use requestAnimationFrame to wait for the next frame
    requestAnimationFrame(() => {
      resolve();
    });
  });
};
